export default "__VITE_ASSET__CU4zI1vz__"